import React, { FC } from 'react';
import { IConfig } from './../../types/config';

import Pagination1 from './Pagination_1';
import { IPagination1 } from './Pagination_1/params';

export interface IPaginationData {
  currentPage: number;
  totalPages: number;
  baseUrl: string;
}

const Pagination: FC<{ config: IConfig; paginationData: IPaginationData }> = ({ config, paginationData }) => {
  switch (config.general.pagination.variant) {
    default:
      return <Pagination1 config={config.general.pagination.params as IPagination1} paginationData={paginationData} />;
  }
};

export default Pagination;
